<section class="section-pd bg-light">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-7 col-lg-7">
                <div class="trinka-title mb-0">
                    <h2>HIPAA 認證</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>平台符合美國醫療健康資訊可攜性與責任法案（HIPAA）規範</p>
                    <p>我們也會與合作夥伴簽署《商業夥伴協議》，以確保持續符合相關合規規範。</p>
                    <p>如果你需要更多資訊或想洽談商業合作，歡迎隨時<a href="javascript:void(0)" (click)="navigationService.goToEnterpriseForm()" class="text-link">聯絡我們!</a>.</p>
                </div>
            </div>
            <div class="col-md-5 col-lg-4 offset-lg-1">
                <div class="text-center">
                    <img src="/assets/images/Hipaa-logo.svg" width="216" height="216" class="img-fluid" style="width:80%" alt="hippa logo" />
                </div>
            </div>
        </div>
    </div>
</section>